import React from "react";
import image_2 from "../../images/agriculture/Picture15.webp";
import image_1 from "../../images/agriculture/Picture2.webp";

const KingOfDates = () => {
  return (
    <section id="king-of-dates">
      <div className="dates-grower-container">
        <div className="ms-13 me-13 pt-7 pb-7 text-center">
          <img src={image_1} className="img-fluid" alt="" />
          <h1 className="fs-56 lh-64 text-uppercase gilroy-bold text-white pt-5">
            King Of Dates
          </h1>
        </div>
      </div>
      <div className="bg-chinese-black text-white">
        <div className="ms-47 me-47 pt-7 pb-7">
          <h1 className="fs-56 lh-64 gilroy-bold text-orange-ryb pb-5">
            Our Production Process
          </h1>
          <p className="fs-20 lh-30 text-align-justify">
            Medjool dates, This king of dates is naturally grown in Egypt
            Garden’ soil. The Medjool variety of dates carries a maple syrup,
            caramel infused like flavor, in a large sized date. Its delicious
            gooey texture is a treat. They are packaged according to client
            request. they are a variety of dates enjoyed for their natural
            sweetness. They’re larger, darker, and more caramel-like in taste
            than other. As soon as the dates are harvested by hand, they are
            immediately stored to halt further ripening and lock in flavors. The
            fruit is then cleaned using state-of-the-art technologies, before
            being assessed and graded to match stringent standards for size,
            colour, translucency and skin condition. This ensures quality,
            consistency and is why every SEGAM dates is the best of the best
          </p>
        </div>
      </div>
      <div className="text-center bg-bright-gray">
        <div>
          <img src={image_2} className="img-fluid" alt="" />
        </div>
      </div>
    </section>
  );
};

export default KingOfDates;
